import api from '../api/axios';

export const getMySourcedProfiles = (startDate, endDate) => api
  .get('/api/profiles/my-sourced', {
    params: {
      startDate: startDate || undefined,
      endDate: endDate || undefined,
    },
  })
  .then((response) => response.data);
